import ConfigurationContext from '../../../core/providers/ConfigurationContext'
import { useContext } from 'react'
import { GPS_ONLY_FEATURES, useCreateSession } from '../useCreateSession'
import { rawTelemetryFromKmhRows } from '../gpsReadings'
import { type UploadFormat } from '../UploadFormat'
import useApi from '../../../api/useApi'
import { type Device } from '@pitbrain/shared'

const AIM: Device = { name: 'AIM', version: '1.0' }

export const useAimProcessor = (): UploadFormat => {
  const bffConfig = useContext(ConfigurationContext)
  const api = useApi(bffConfig)
  const createSession = useCreateSession(api)

  const processFile = async (file: File, sessionId: string): Promise<void> => {
    const results = await api.fileApi.convertXrkFile(file)
    const rawTelemetry = rawTelemetryFromKmhRows(results, AIM)
    await createSession(rawTelemetry, {
      sessionId,
      fileName: file.name,
      device: AIM,
      sessionFeatures: GPS_ONLY_FEATURES,
    })
  }

  return {
    extensions: ['.XRK'],
    keepsFileAsSource: true,
    processFile,
    error: api.error,
  }
}
